// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__XyNvv","tab_slider":"styles_tab_slider__a2Ajn","content_container":"styles_content_container__9waaC"};